module.exports = __webpack_public_path__ + "static/media/37.2cad9387.JPG";